export const EDIS_HISTORY_DATA = "EDIS_HISTORY_DATA";
export const EDIS_HISTORY_START_LOADER = "EDIS_HISTORY_START_LOADER";
export const EDIS_HISTORY_STOP_LOADER = "EDIS_HISTORY_STOP_LOADER";
export const EDIS_HISTORY_HIDE_ERROR = "EDIS_HISTORY_HIDE_ERROR";
export const EDIS_HISTORY_ERROR = "EDIS_HISTORY_ERROR";
